import { render, staticRenderFns } from "./newList.vue?vue&type=template&id=64d6b2c0&"
import script from "./newList.vue?vue&type=script&lang=js&"
export * from "./newList.vue?vue&type=script&lang=js&"
import style0 from "./newList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports